import React, { useEffect, useState } from 'react';
import { TextField, Button, Stack } from '@mui/material';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
function AddDetails() {
    const [data, setData] = useState([]);
    const [value, setValue] = useState({
        firstName: '',
        lastName: '',
        email: '',
        contactNo: '',
        country: '',
        state: '',
        city: '',
        addressLine1: '',
        addressLine2: '',
    });
    const { id } = useParams();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setValue((prevState) => ({ ...prevState, [name]: value }));
    };

    const handleApicall = async () => {
        try {
            const response = await axios.get('https://generativebackend.onrender.com/api/employeeData');
            setData(response.data.employeeData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        handleApicall();
    }, []);

    useEffect(() => {
        if (id) {
            let currentid = data.find((item) => item._id === id);
            if (currentid) {
                setValue(currentid);
            }
        }
    }, [id, data]);
    const handleSubmit = async (event) => {
        event.preventDefault();
        const { firstName, lastName, email, contactNo, country, state, city, addressLine1, addressLine2 } = value;

        try {
            if (id) {
                const response = await axios.put(`https://generativebackend.onrender.com/api/employeeData/${id}`, {
                    firstName,
                    lastName,
                    email,
                    contactNo,
                    country,
                    state,
                    city,
                    addressLine1,
                    addressLine2,
                });

                if (response.status === 200) {
                    console.log('data updated Sucessfully');
                    setValue({
                        firstName: '',
                        lastName: '',
                        email: '',
                        contactNo: '',
                        country: '',
                        state: '',
                        city: '',
                        addressLine1: '',
                        addressLine2: '',
                    });
                    toast.success('Data updated Sucessfully');
                } else {
                    alert('Please fill in all details');
                }
            } else {
                const response = await axios.post('https://generativebackend.onrender.com/api/employeeData', {
                    firstName,
                    lastName,
                    email,
                    contactNo,
                    country,
                    state,
                    city,
                    addressLine1,
                    addressLine2,
                });

                if (response.status === 200) {
                    setValue({
                        firstName: '',
                        lastName: '',
                        email: '',
                        contactNo: '',
                        country: '',
                        state: '',
                        city: '',
                        addressLine1: '',
                        addressLine2: '',
                    });
                    toast.success(response.data.message);
                    console.log(response);
                } else {
                    alert('Please fill in all details');
                }
            }
        } catch (error) {

            console.log('Error submitting form:', error);
            toast.error(error.response.data.message);
        }
    };

    return (
        <React.Fragment>
            <h2>Add Employee Detail</h2>
            <form onSubmit={handleSubmit}>
                <Stack spacing={2} direction="row" sx={{ marginBottom: 4 }}>
                    <TextField
                        type="text"
                        variant="outlined"
                        color="secondary"
                        label="First Name"
                        name="firstName"
                        value={value.firstName}
                        onChange={handleChange}
                        fullWidth
                        required
                    />
                    <TextField
                        type="text"
                        variant="outlined"
                        color="secondary"
                        label="Last Name"
                        name="lastName"
                        value={value.lastName}
                        onChange={handleChange}
                        fullWidth
                        required
                    />
                </Stack>
                <Stack spacing={2} direction="row" sx={{ marginBottom: 4 }}>
                    <TextField
                        type="email"
                        variant="outlined"
                        color="secondary"
                        label="Email"
                        name="email"
                        value={value.email}
                        onChange={handleChange}
                        fullWidth
                        required
                        sx={{ mb: 4 }}
                    />
                    <TextField
                        type="number"
                        variant="outlined"
                        color="secondary"
                        label="Contact No"
                        name="contactNo"
                        value={value.contactNo}
                        onChange={handleChange}
                        fullWidth
                        required
                        sx={{ mb: 4 }}
                    />
                </Stack>
                <Stack spacing={2} direction="row" sx={{ marginBottom: 4 }}>
                    <TextField
                        type="text"
                        variant="outlined"
                        color="secondary"
                        label="Country"
                        name="country"
                        value={value.country}
                        onChange={handleChange}
                        fullWidth
                        required
                        sx={{ mb: 4 }}
                    />
                    <TextField
                        type="text"
                        variant="outlined"
                        color="secondary"
                        label="State"
                        name="state"
                        value={value.state}
                        onChange={handleChange}
                        fullWidth
                        required
                        sx={{ mb: 4 }}
                    />
                    <TextField
                        type="text"
                        variant="outlined"
                        color="secondary"
                        label="City"
                        name="city"
                        value={value.city}
                        onChange={handleChange}
                        fullWidth
                        required
                        sx={{ mb: 4 }}
                    />
                </Stack>
                <Stack spacing={2} direction="row" sx={{ marginBottom: 4 }}>
                    <TextField
                        id="outlined-textarea"
                        label="Address Line 1"
                        name="addressLine1"
                        fullWidth
                        multiline
                        value={value.addressLine1}
                        onChange={handleChange}
                        sx={{ mb: 4 }}
                    />
                    <TextField
                        id="outlined-textarea"
                        label="Address Line 2"
                        name="addressLine2"
                        fullWidth
                        multiline
                        value={value.addressLine2}
                        onChange={handleChange}
                        sx={{ mb: 4 }}
                    />
                </Stack>

                <Button sx={{ alignItems: 'center' }} variant="outlined" color="secondary" type="submit">
                    Register
                </Button>
            </form>
        </React.Fragment>
    );
}

export default AddDetails;
